/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IContentBlockViewProps } from '@msdyn365-commerce-modules/content-block';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

const ContentBlockView: React.FC<IContentBlockViewProps> = (props) => {
  const {
    contentBlockContainer,
    imageContainer,
    detailsContainer,
    title,
    text,
    links,
    image,
    contentBlockAnchorTag,
    imageLink,
    imageAriaLabel
  } = props;
  contentBlockContainer.className = image === undefined ? contentBlockContainer.className.concat(' emptyImage') : contentBlockContainer.className;
  if (imageLink) {
    return (
      <Module {...contentBlockContainer}>
        <Node
          {...contentBlockAnchorTag}
          href={imageLink}
          className={contentBlockAnchorTag ? contentBlockAnchorTag.className : ''}
          aria-label={imageAriaLabel}
        >
          <Node {...imageContainer}>{image}</Node>
          <Node {...detailsContainer}>
            {title}
            {text}
            {links}
          </Node>
        </Node>
      </Module>
    );
  } else {
    return (
      <Module {...contentBlockContainer}>
        <Node {...imageContainer}>{image}</Node>
        <Node {...detailsContainer}>
          {title}
          {text}
          {links}
        </Node>
      </Module>
    );
  }
};

export default ContentBlockView;
